"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initFreeGuides = initFreeGuides;
const functions_1 = require("firebase/functions");
const firebase_1 = require("./firebase");
const free_guides_svg_1 = __importDefault(require("./assets/icons/free-guides.svg"));
function initFreeGuides(container) {
    let freeGuidesHTML = `
      <div class="free-guides">
        <div class="section-heading">Free guides</div>
        <div class="free-guides-form">
            <div class="icon-wrapper">
                <img src="${free_guides_svg_1.default}" alt="Free guides icon"/>
            </div>
            <div class="form-wrapper">
                <div class="info">Grab your free guide for first-time <br/>homebuyers today!</div>
                <div class="fields">
                    <input type="text" class="name-field" placeholder="Name" />
                    <input type="email" class="email-field" placeholder="Email" />
                    <div class="submit-button disabled">Yes, I want this</div>
                </div>
                <div class="consent-wrapper">
                    <input type="checkbox" id="consent-checkbox" name="consent" value="Promotional emails consent">
                    <label for="consent-checkbox">I consent to use my details here for future promotional emails.</label>
                </div>
            </div>
        </div>
      </div>
    `;
    container.innerHTML = freeGuidesHTML;
    const formWrapper = container.querySelector(".free-guides-form .form-wrapper");
    const fields = container.querySelector(".free-guides-form .fields");
    const consentWrapper = container.querySelector(".free-guides-form .consent-wrapper");
    const nameField = container.querySelector(".free-guides-form .name-field");
    const emailField = container.querySelector(".free-guides-form .email-field");
    const consentField = container.querySelector(".free-guides-form #consent-checkbox");
    const submitBtn = container.querySelector(".free-guides-form .submit-button");
    const validateForm = () => __awaiter(this, void 0, void 0, function* () {
        const name = nameField.value;
        const email = emailField.value;
        if (name && email && validateEmail(email)) {
            submitBtn.classList.remove("disabled");
        }
        else {
            submitBtn.classList.add("disabled");
        }
    });
    const validateEmail = (email) => {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(email);
    };
    nameField.addEventListener("change", (event) => {
        validateForm();
    });
    emailField.addEventListener("change", (event) => {
        validateForm();
    });
    consentField.addEventListener("change", (event) => {
        validateForm();
    });
    submitBtn.addEventListener("click", (event) => __awaiter(this, void 0, void 0, function* () {
        const name = nameField.value.trim();
        const email = emailField.value.trim();
        const consent = consentField.checked;
        try {
            submitBtn.textContent = "Processing...";
            submitBtn.disabled = true;
            submitBtn.classList.toggle("disabled");
            const functions = yield (0, firebase_1.getFirebaseFunctions)();
            const sendGuideEmail = (0, functions_1.httpsCallable)(functions, "sendGuideEmail");
            const response = yield sendGuideEmail({ name, email, consent, file: "test-1.pdf" });
            const responseData = response.data;
            if (responseData.success) {
                fields.remove();
                consentWrapper.remove();
                const statusElement = document.createElement("div");
                statusElement.classList.add("status");
                statusElement.classList.add("success");
                statusElement.textContent = "Your homebuyer free guide has been emailed to you!";
                formWrapper.appendChild(statusElement);
            }
            else {
                submitBtn.textContent = "Yes, I want this";
                submitBtn.disabled = false;
                submitBtn.classList.toggle("disabled");
                const statusElement = document.createElement("div");
                statusElement.classList.add("status");
                statusElement.classList.add("error");
                statusElement.textContent = responseData.message;
                formWrapper.appendChild(statusElement);
            }
        }
        catch (error) {
            submitBtn.textContent = "Yes, I want this";
            submitBtn.disabled = false;
            submitBtn.classList.toggle("disabled");
            console.error("Error sending email:", error);
            const errorString = error;
            const statusElement = document.createElement("div");
            statusElement.classList.add("status");
            statusElement.classList.add("error");
            statusElement.textContent = errorString;
            formWrapper.appendChild(statusElement);
        }
    }));
}
